// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'b2dec8bc';
